import src from "IMAGE";
export default { src, width: 49, height: 93, blurWidth: 0, blurHeight: 0};
